import { sortPartialDate } from 'neuro-utils';
import { mgravisDiagnoses } from 'Routes/Diagnosis/utils/definitions';
import { filterByDocumentType } from 'Utility/documentHandling';
import { defineDocConfig } from './utils';

export const mgravisDocumentTypes = defineDocConfig([
  {
    name: 'diagnosis',
    subTypes: ['diagnosis', 'mgravisSymptoms', 'mgfa'],
  },
  { name: 'medication', subTypes: ['medication', 'adverseEffect'] },
  { name: 'functionalPerformanceMgravis', subTypes: ['mgc', 'mgadl'] },
  { name: 'comorbidity', subTypes: ['hospitalization'] },
  {
    name: 'procedure',
    subTypes: ['procedure'],
    subTypesFiltering: { procedure: d => d?.code?.code === '19647005' || d?.code?.code === '399750009' },
  },
  { name: 'imaging', subTypes: ['thymusCt', 'thymusMri'] },
  { name: 'clpAndCnpTests', subTypes: ['diagnosticExamination'] },
  { name: 'examination' },
  { name: 'diagnosticTests', subTypes: ['diagnosticExamination'] },
  { name: 'background', subTypes: ['background', 'measurement'] },
  { name: 'myService', title: 'titleShort' },
]);

export const mgravisGraphDocTypes = [
  'diagnosis',
  'mgravisSymptoms',
  'medication',
  'adverseEffect',
  'mgc',
  'mgadl',
  'mgfa',
  'background',
  'diagnosticExamination',
  'procedure',
  'hospitalization',
  'thymusCt',
  'thymusMri',
] satisfies TDocumentType[];

export const mgravisAlerts: IAlert[] = [
  {
    // Notification to the user if a diagnosis document is recorded before a mgravisSymptoms document
    content: 'alerts.mgravis.symptomOnsetDateAfterDiagnosisDate',
    id: 'mgravisSymptomOnsetDateAfterDiagnosisDate',
    severity: 'warning',
    popup: true,
    rule: (docs: Array<IDocumentV2> | undefined = []): boolean => {
      // Find first Mgravis diagnosis document (docs should be sorted descending by commitDate)
      const mgravisDiagnosisDoc = filterByDocumentType(docs, 'diagnosis').find(
        d => 'diagnosis' in d && (mgravisDiagnoses as string[]).includes(d.diagnosis ?? ''),
      );
      const mgravisDiagnosisDate = mgravisDiagnosisDoc?.date;

      // Find first Mgravis diagnosis document (docs should be sorted descending by commitDate)
      const mgravisSymptomsDoc = docs.find(d => d._type === 'mgravisSymptoms');
      const mgravisSymptomOnsetDate = mgravisSymptomsDoc?.date;

      if (!mgravisDiagnosisDate || !mgravisSymptomOnsetDate) return false;
      return sortPartialDate(mgravisSymptomOnsetDate, mgravisDiagnosisDate) > 0;
    },
  },
];
